module.exports = __webpack_public_path__ + "img/google.45aebcf8.svg";